import { TFilterSelected, TRESPONSE_TNA_BOARD_LISTING } from '@monorepo/types';
import { UTILS_GUARDS } from '../ui-filter.guards';
import { UiFilterModifiers } from '../ui-filter.modifier';
import { TFilterGroupModel, TOrgFilter } from '../ui-filter.types';

export const TNA_BOARD_FILTER_MODEL = {
  createModel: (
    items: TFilterSelected[],
    searchUrl: string,
    stripStatusMetadataMap?: TRESPONSE_TNA_BOARD_LISTING['stripStatusMetadataMap'],
    extraPayloadForSearch?: any,
    prevModel?: TFilterGroupModel<TFilterSelected>,
    orgHierarchySelectedTree?: TOrgFilter['dynamicOrgHierarchy'],
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isSelectFilter(item)) {
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          searchWithApi: item.searchable
            ? {
                searchService: 'plani8',
                searchUrl,
                payload: extraPayloadForSearch,
              }
            : undefined,
          items: item.values.map((supportedVal) => {
            const valueTypeCast = supportedVal as keyof TRESPONSE_TNA_BOARD_LISTING['stripStatusMetadataMap'];
            return {
              value: supportedVal,
              isSelected: false,
              displayText:
                stripStatusMetadataMap && stripStatusMetadataMap[valueTypeCast]
                  ? stripStatusMetadataMap[valueTypeCast].displayName
                  : '',
            };
          }),
          selectedValues: [],
        };
      }
      if (UTILS_GUARDS.isDurationFilter(item)) {
        return {
          type: 'DURATION_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            value: val,
            isSelected: false,
          })),
          selectedValues: [],
        };
      }
      if (UTILS_GUARDS.isOrgFilter(item)) {
        return {
          type: 'ORG_HIERARCHY_FILTER',
          key: item.key,
          displayName: item.displayName,
          hierarchy: item,
          isDisabled: false,
          ...(orgHierarchySelectedTree && {
            dynamicOrgHierarchy: orgHierarchySelectedTree,
          }),
          filteredOrgTree: {
            ...item,
            values: [],
          },
        };
      }
      throw new Error('Type Not suppported');
    });
    const updatedFilterModel = prevModel
      ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel)
      : createNewFilterModel;
    return UiFilterModifiers.sortFilterItems(updatedFilterModel);
  },
};

export const LINE_LEVEL_STRIP_LIST_FILTER_CONTAINER_MODEL = {
  createModel: (
    items: TFilterSelected[],
    selectedItems: TFilterSelected[],
    prevModel?: TFilterGroupModel<TFilterSelected>,
  ) => {
    const createNewFilterModel = UiFilterModifiers.createFilterModelList(items, (item) => {
      if (UTILS_GUARDS.isSelectFilter(item)) {
        const currKeySelectedValues = selectedItems.find((itms) => itms.key === item.key)?.values as (
          | string
          | number
        )[];
        return {
          type: 'SELECT_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((supportedVal) => {
            return {
              value: supportedVal,
              isSelected: currKeySelectedValues?.find((slcItm) => slcItm === supportedVal) ? true : false,
            };
          }),
          selectedValues: [],
        };
      }
      if (UTILS_GUARDS.isDurationFilter(item)) {
        return {
          type: 'DURATION_FILTER',
          key: item.key,
          displayName: item.displayName,
          items: item.values.map((val) => ({
            value: val,
            isSelected: true,
          })),
          selectedValues: [],
        };
      }
      throw new Error('Type Not suppported');
    });
    const updatedFilterModel = prevModel
      ? UiFilterModifiers.updateFilterModelList(createNewFilterModel, prevModel)
      : createNewFilterModel;
    return UiFilterModifiers.sortFilterItems(updatedFilterModel);
  },
};
